import React, { Component } from "react";

export default class PrintButton extends Component {
  handlePrint = () => {
    if (this.props.printHandler) {
      this.props.printHandler();
    } else {
      window.print();
    }
  };

  render() {
    const {disabled=false} = this.props;
    return (
      <button
        disabled={disabled}
        style={{ marginBottom: 10 }}
        onClick={this.handlePrint}
        className="pull-right btn btn-primary"
      >
        <span className="fa fa-print" /> Print
      </button>
    );
  }
}
